import { wrapCreateBrowserRouter } from '@sentry/react/react-router';
import { createBrowserRouter } from 'react-router-dom';
import { routes } from './routes';

// Names performance transactions by route pattern (/providers/:id); inert unless tracing is enabled.
const createInstrumentedRouter = wrapCreateBrowserRouter(createBrowserRouter);

/** Created by main.tsx once routes are ready (approach B resolves lazy routes first). */
export const createAppRouter = () => createInstrumentedRouter(routes);
